import { ACTION_ROW_CLASS, ActionRowBody, ActionRowChevron } from '@/components/action-items-table'
import type { components } from '@/api/schema'

type ProjectAction = components['schemas']['ProjectOpenActionRead']

/** Ops's items on this PO's supplier invoices, one row each; a row opens the item on its invoice (USA-1641). */
export function POInvoiceActionRows({ actions }: { actions: readonly ProjectAction[] }) {
  if (actions.length === 0) return null
  return (
    <ul aria-label="Invoice action items" className="divide-y overflow-hidden rounded-lg border bg-background">
      {actions.map((action) => (
        <li key={action.uuid} className={ACTION_ROW_CLASS}>
          {/* The page is this PO: rows name their invoice, not the PO or its manufacturer. "" makes the row a link. */}
          <ActionRowBody action={{ ...action, po_number: null, manufacturer_name: null }} projectUuid="" />
          <ActionRowChevron />
        </li>
      ))}
    </ul>
  )
}
